<template>
  <div class="bannerBox">
      <LayoutHeader />
      <div class="banner-box">
          <img src="@/assets/home/qypyk-banner.jpg" alt="">
          <div class="text">企业培育库</div>
          <div class="text1">大力推进高新技术企业培育库，不断壮大创新型企业集群</div>
      </div>
      <div class="breadBox">
          <div class="child">
              <a-breadcrumb>
          <span>
            当前位置：
          </span>
                  <a-breadcrumb-item style="cursor: pointer;" @click="this.$router.push('/')">首页</a-breadcrumb-item>
                  <a-breadcrumb-item>{{title}}</a-breadcrumb-item>
              </a-breadcrumb>
          </div>

      </div>
  </div>
  <div class="menuContentBox">
      <router-view/>
  </div>
  <LayoutFooter />
</template>
<script>
import LayoutHeader from '@/layout/layoutPage/header/LayoutHeaderNew2';
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2'
export default {
  name: 'investor',
    components: {
        LayoutHeader,
        LayoutFooter
    },
  props: {
  },
  data() {
    return {
      title:''
    }
  },
  mounted() {
    this.title = this.$route.query.type
  },
	methods: {
		goMore(url,key) {
      this.$router.push({
				path: url,
				query: { type: key }
			})
      this.$parent.$parent.clearHeadFun()
		},
		backhome() {
			this.$router.push('/')
		}
	}
}
</script>
<style scoped lang="less">
@import "../../css/components.less";
.breadBox{
    width: 100%;
    border-bottom: 1px solid #DEDEDE;
    .child{
        width: 1200px;
        margin:0 auto;
        padding:20px 0;

    }
}
.banner-box{
    position: relative;
    img{
        width: 100%;
        height: 240px;
        object-fit: cover;
    }
    .text{
        position: absolute;
        top: 60px;
        width: 1200px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        left:50%;
        transform: translateX(-50%);
        font-weight: 400;
        font-size: 36px;
        color: #FFFFFF;
        line-height: 50px;
    }
    .text1{
        position: absolute;
        top: 120px;
        width: 1200px;
        left:50%;
        transform: translateX(-50%);
        font-weight: 400;
        font-size: 18px;
        color: #FFFFFF;
    }
}
.menuContentBox{
  background: #fff;
  overflow: auto;
  width:1200px;
  margin:20px auto;
    padding:10px 30px;
  //margin-top: -10px;
}
.bannerBox {
  position: relative;
  width: 100%;
  //margin-bottom: 20px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }
}
</style>
